export const apiBaseUrlClean = 'api.sales.ekompanija.com';
export const kpsBaseUrlClean = 'kps.demo.ekompanija.com';
export const mixpanelToken = '716207ba0cc068bb3aa96e5424302e2a';
export const storageUrlClean = 'ekompanija-demo.fra1.digitaloceanspaces.com';

export const environment = {
  production: true,
  apiBaseUrl: `https://${apiBaseUrlClean}`,
  kpsBaseUrl: `https://${kpsBaseUrlClean}`,
  version: '2.6.0',
  firebase: {
    apiKey: 'AIzaSyBh2Lbv8Zij4pV1lGHbxSUX9WtnffdnMj8',
    authDomain: 'ekompanija-4fde1.firebaseapp.com',
    projectId: 'ekompanija-4fde1',
    storageBucket: 'ekompanija-4fde1.firebasestorage.app',
    messagingSenderId: '142074200795',
    appId: '1:142074200795:web:154326093fa72ae99342fe',
    measurementId: 'G-J206N195ZH',
  },
  extremeMaintenance: false,
  timerMaintenanceMs: 3000, // u milisekundama se vrti provera za maintenance
  canResetEverything: true,
  posthogKey: 'phc_AgHg2shgn9bl1hq8xI51EDKCMx5d4uQtf7mWwNnmGB7',
};
